module.exports = __webpack_public_path__ + "img/sschoen.731523ec.jpg";